<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.2619 14.9722C10.8588 15.6687 12 15.2465 12 14.3293C12 14.1155 11.9307 13.9075 11.8024 13.7365L8.99999 10L11.8024 6.26345C11.9307 6.09244 12 5.88445 12 5.67069C12 4.75347 10.8588 4.33133 10.2619 5.02773L6.00001 9.99998L10.2619 14.9722Z"
    fill="currentColor"
  />
</svg>
